import type { TOC } from '@ember/component/template-only';
import ModalPropertyAccess from 'lumen/components/settings/users/modals/modal-property-access';
import type HotelSettingsUsersPropertyAccessController from 'lumen/controllers/hotel/settings/users/property-access';

interface HotelSettingsUsersPropertyAccessSignature {
  Args: {
    controller: HotelSettingsUsersPropertyAccessController;
  };
}

const HotelSettingsUsersPropertyAccess: TOC<HotelSettingsUsersPropertyAccessSignature> =
  <template>
    <ModalPropertyAccess
      @isLoading={{@controller.isLoading}}
      @isLoadingMore={{@controller.isLoadingMore}}
      @isOwnUser={{@controller.isOwnUser}}
      @onAddAccess={{@controller.addPropertyAccess}}
      @onBulkDelete={{@controller.bulkDelete}}
      @onClose={{@controller.close}}
      @onDelete={{@controller.deleteRelationship}}
      @onLoadMore={{@controller.onLoadMore}}
      @onProductChange={{@controller.onProductChange}}
      @onRoleChange={{@controller.onRoleChange}}
      @onSave={{@controller.saveChanges}}
      @onSearchChange={{@controller.onSearchChange}}
      @onSortChange={{@controller.onSortChange}}
      @product={{@controller.product}}
      @relationships={{@controller.relationships}}
      @role={{@controller.role}}
      @searchText={{@controller.searchText}}
      @sorts={{@controller.sorts}}
      @userEmail={{@controller.userEmail}}
      @userId={{@controller.userId}}
    />
  </template>;

export default HotelSettingsUsersPropertyAccess;
